const HEATMAP_PAGE_WIDTH = 650;
const HEATMAP_SCROLL_OFFSET = 80;

const config = {
  DEBUG_MODE: false,
  HEATMAP_PAGE_WIDTH,
  HEATMAP_SCROLL_OFFSET,
  HEATMAP_OFFSET: 200,
  STORY_PAGE_OFFSET: 24,
  HIGH_IMPACT: 0.7,
  MEDIUM_IMPACT: 0.3,
  LOW_IMPACT: 0,
  GENERATOR_OFFSET_Y: 0,
  GENERATOR_OFFSET_X: 0,
  STORY_PAGE_HEADER_HEIGHT: 98,
  STORY_MAX_ELEMENTS_PER_PAGE: 5,
  TOP_BAR_HEIGHT: 70,

  AB_SELECTOR_WIDTH: HEATMAP_SCROLL_OFFSET + 70,
  AB_SELECTOR_PADDING: HEATMAP_PAGE_WIDTH - HEATMAP_SCROLL_OFFSET - 46,

  VALID_PREVIEW_EXTENSIONS: [".png", ".jpg", ".jpeg", ".gif", ".svg"],

  LUXIFER_AI_PFP:
    "https://firebasestorage.googleapis.com/v0/b/ux-pro.appspot.com/o/users%2FLUXI.png?alt=media",

  PLACEHOLDER_PAGE:
    "https://firebasestorage.googleapis.com/v0/b/ux-pro.appspot.com/o/projects%2FAPoA38cgCp0Fc7UAesHK%2Fa00a1691-9e6a-4045-a1e4-2c0253d20497.jpg?alt=media",

  PLACEHOLDER_IMAGE:
    "https://firebasestorage.googleapis.com/v0/b/ux-pro.appspot.com/o/public%2Fdog.jpg?alt=media",

  PREMADE_AI_QUESTIONS: {
    1: "Which pages have the highest bounce rate?",
    2: "Which goals have the best and worst performance?",
    5: "What is the current ROI from site users?",
    6: "Which pages show the highest user frustration (rage clicks, hesitation)?",
    8: "Which pages are the slowest to load?",
    13: "What are the potential gains if I improve friction points?",
    16: "Which pages are most frequently viewed by users?",
    18: "What percentage of users are returning visitors?",
    21: "Which high-impact insights still require attention?",
    28: "How have my conversions evolved over time?",
  },

  TAKE_ACTIONS_ICONS: {
    "Add a purchase value": "fa-cart-shopping",
    "Install the script on your website": "fa-code",
  },
};

export default config;
